import React, { Component } from 'react'
import LoadingSpinner from './LoadingSpinner'
import Auth from '../auth/Auth'

class LoginComponent extends Component {
  componentDidMount() {
    Auth.login()
  }
  render() {
    return <LoadingSpinner />
  }
}

export default LoginComponent



// WEBPACK FOOTER //
// ./src/components/LoginComponent.js